import './ProductSection.css';
import pike1 from '../assets/pike_rov.png';
import pikeauv from '../assets/pike_auv.png';

const ProductSection = () => {
  const products = [
    {
      name: "PIKE ROV",
      tagline: "Remotely Operated Vehicle",
      description: "Tethered ROV optimised for real-time control, intervention tasks, and precision underwater operations. Continuous power via tether enables extended missions with live video feed and immediate operator response.",
      image: pike1,
      specs: [
        { label: "Depth", value: "300m" },
        { label: "Speed", value: "4 m/s" },
        { label: "Runtime", value: "4h" },
        { label: "Tether", value: "Yes" }
      ],
      capabilities: [
        "Real-time visual inspection & control",
        "Flexible sensor integration",
        "Rapid deployment, reduced downtime"
      ],
      useCases: ["Infrastructure Inspection", "Search & Rescue", "Mine Countermeasures", "Marine Monitoring"],
      badge: "ROV"
    },
    {
      name: "PIKE AUV",
      tagline: "Autonomous Underwater Vehicle",
      description: "Long-range AUV for survey-grade missions and defence operations. Operates fully independently without surface vessel support, featuring integrated sonar and photogrammetry for detection and documentation.",
      image: pikeauv,
      specs: [
        { label: "Range", value: "80km" },
        { label: "Depth", value: "300m" },
        { label: "Speed", value: "3 m/s" },
        { label: "Payload", value: "10kg" }
      ],
      capabilities: [
        "Fully autonomous, no vessel required",
        "Survey-grade hydrography",
        "Modular payload architecture"
      ],
      useCases: ["Mine Countermeasures", "Port Security", "Pipeline Inspection", "Environmental Monitoring"],
      badge: "AUV"
    }
  ];

  return (
    <section className="products" id="products">
      <div className="container">
        {/* Section Header */}
        <div className="section-header">
          <span className="section-label">Unmanned Underwater Vehicles</span>
          <h2 className="section-title">
            Autonomous
            <span className="gradient-text"> Platforms</span>
          </h2>
          <p className="section-subtitle">
            Purpose-built autonomous systems designed for the most demanding underwater missions.
          </p>
        </div>

        {/* Products Grid */}
        <div className="products-grid">
          {products.map((product, index) => (
            <div className={`product-card ${product.featured ? 'featured' : ''}`} key={index}>
              {/* Product Badge */}
              <div className="product-badge">{product.badge}</div>

              {/* Product Image */}
              <div className="product-image-container">
                <img src={product.image} alt={product.name} className={`product-image product-image-${product.badge.toLowerCase()}`} />
              </div>

              {/* Product Info */}
              <div className="product-info">
                <h3 className="product-name">{product.name}</h3>
                <p className="product-tagline">{product.tagline}</p>
                <p className="product-description">{product.description}</p>

                {/* Capabilities */}
                <ul className="product-capabilities">
                  {product.capabilities.map((cap, capIndex) => (
                    <li key={capIndex}>{cap}</li>
                  ))}
                </ul>

                {/* Use Cases */}
                <div className="product-use-cases">
                  {product.useCases.map((useCase, ucIndex) => (
                    <span className="use-case-tag" key={ucIndex}>{useCase}</span>
                  ))}
                </div>

                {/* Specs Grid */}
                <div className="product-specs">
                  {product.specs.map((spec, specIndex) => (
                    <div className="spec-item" key={specIndex}>
                      <span className="spec-value">{spec.value}</span>
                      <span className="spec-label">{spec.label}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="products-cta">
          <p>Interested in our products?</p>
          <button className="btn btn-primary" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>
            Request Specifications
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default ProductSection;
